import {
  GetAssetsApiResponse,
  GetModelPresetsByModelIdApiResponse,
} from "infra/api/generated/api";

export function mapPresetsToAssets(
  presets: GetModelPresetsByModelIdApiResponse["presets"]
): GetAssetsApiResponse["assets"] {
  return presets.map((preset) => ({
    metadata: {
      ...preset.parameters,
      modality: preset.parameters
        .modality as GetAssetsApiResponse["assets"][0]["metadata"]["modality"],
      concepts: preset.parameters.concepts?.map((concept) => ({
        ...concept,
        weightName: "",
      })),
      kind: "image",
      type: ("inference-" +
        preset.parameters
          .type) as GetAssetsApiResponse["assets"][0]["metadata"]["type"],
      parentId: preset.parameters.imageId,
    },
    kind: "image",
    source: "inference-txt",
    properties: {
      size: 0,
    },
    url: "",
    createdAt: new Date().toISOString(),
    modelId: preset.modelId,
    id: preset.id,
    authorId: "",
    ownerId: "",
    mimeType: "application/json",
    tags: [],
    collectionIds: [],
    editCapabilities: [],
    status: "success",
    privacy: "public",
    updatedAt: new Date().toISOString(),
  }));
}
